module.exports = __webpack_public_path__ + "static/media/bnr4.dc3e4916.jpg";